<template lang="html">
  <div
    class="icon-container"
    :class="{'hovered': hover || active}">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
         class="icon vertical-align-middle" @mouseenter="entered" @mouseleave="left">
      <g v-if="hover || active" fill="none" fill-rule="evenodd"
         transform="translate(10, 4)">
         <path d="M0 0h24v24H0z"/>
         <path d="M0 0h24v24H0z"/>
         <path fill="#FFF" d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z"/>
      </g>
      <g v-else fill="none" fill-rule="evenodd"
         transform="translate(10, 4)">
         <path d="M0 0h24v24H0z"/>
         <path d="M0 0h24v24H0z"/>
         <path fill="#323C44" d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z"/>
      </g>
    </svg>
  </div>
</template>

<script>
  export default {
    props: ['active', 'hasHoverState'],
    data() {
      return {
        hover: false,
      };
    },
    methods: {
      entered() {
        if (this.hasHoverState) {
          this.hover = true;
          this.$emit('entered');
        }
      },
      left() {
        this.hover = false;
        this.$emit('left');
      },
    },
  };
</script>

<style lang="scss" scoped>

  /* - Colour - */

  $primary-accent-color: #50e3c2;

  .icon {
    cursor: pointer;
    height: 24px;
    width: 40px;
  }

  .icon-container {
    border-radius: 20px;
    height: 24px;
    width: 40px;
  }

  .hovered {
    background-color: $primary-accent-color;
  }

</style>



// WEBPACK FOOTER //
// src/lib/rare-patternlab/src/components/icons/communication/RareEmailIcon.vue